import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router";

const ServiceRequestLayout = lazy(
  () => import("pages/service-request/[serviceRequestId]/ServiceRequestLayout"),
);
const ServiceRequestMessagesPage = lazy(
  () =>
    import(
      "pages/service-request/[serviceRequestId]/messages/ServiceRequestMessagesPage"
    ),
);
const ServiceRequestsPage = lazy(
  () => import("pages/service-request/ServiceRequestsPage"),
);
const ServiceRequestAttachmentsPage = lazy(
  () =>
    import(
      "pages/service-request/[serviceRequestId]/attachments/RequestAttachmentsPage"
    ),
);

const ServiceRequestRoutes = () => (
  <Routes>
    <Route element={<ServiceRequestsPage />} path={"/:serviceRequestId?"}>
      <Route element={<ServiceRequestLayout />}>
        <Route element={<ServiceRequestAttachmentsPage />} path="attachments" />
        <Route element={<ServiceRequestMessagesPage />} path="messages" />
        <Route element={<Navigate to="messages" />} index />
      </Route>
    </Route>
  </Routes>
);

export default ServiceRequestRoutes;
